const mapSearchUrl = (query) =>
  query ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}` : undefined;

export const getAreaLandmarkMapUrl = (profile) => {
  const address = typeof profile?.address === "string" ? profile.address : "";
  // Address values may contain commas; stop only at the next labelled field.
  const fields = {};
  const pattern = /(?:^|,)\s*([^,:]+):\s*([\s\S]*?)(?=,\s*[^,:]+:|$)/g;
  for (const match of address.matchAll(pattern)) {
    fields[match[1].trim().toLowerCase()] = match[2].trim();
  }
  const area = fields.area || profile?.area;
  const landmark = fields.landmark || profile?.landmark || profile?.landMark;
  return mapSearchUrl([area, landmark].filter(Boolean).join(", "));
};

export const getCoordinatesMapUrl = (profile) => {
  // This API stores coordinates as [latitude, longitude].
  const coordinates = profile?.location?.coordinates;
  if (!Array.isArray(coordinates) || coordinates.length !== 2) return undefined;
  if (coordinates.some((value) => value == null || String(value).trim() === "")) {
    return undefined;
  }
  const [lat, lng] = coordinates.map(Number);
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) {
    return undefined;
  }
  return mapSearchUrl(`${lat},${lng}`);
};
